import ReplyIcon from '@mui/icons-material/Reply';
import { LinkedinTypes } from 'enums';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TmMessageReplyTask } from './task-manager.types';
import { getTaskInitials, TmSectionCard, TmTaskRow } from './tm-section-card';

interface ItemProps {
  task: TmMessageReplyTask;

  handleMessageReplyTaskClick(funnelId: string, liAccountId: string | undefined): () => void;
}

const TaskItem: React.FC<ItemProps> = ({ task, handleMessageReplyTaskClick }) => {
  const { t } = useTranslation();

  const { funnelId, funnelName, linkedinAccount, unreadMessagesCount } = task;

  // Ohne Konto (gelöscht) stand hier „undefined undefined": die Vorlage setzte fehlende
  // Namensteile als Text ein.
  const userName = linkedinAccount
    ? _.compact([linkedinAccount.firstName, linkedinAccount.lastName]).join(' ')
    : t('taskAccountDeleted');

  const productLabel =
    linkedinAccount?.liProductType === LinkedinTypes.LINKEDIN
      ? 'LinkedIn'
      : linkedinAccount?.liProductType === LinkedinTypes.SALES_NAV
        ? 'Sales Navigator'
        : linkedinAccount?.liProductType === LinkedinTypes.RECRUITER
          ? 'Recruiter'
          : '';

  return (
    <TmTaskRow
      initials={getTaskInitials(linkedinAccount?.firstName, linkedinAccount?.lastName, linkedinAccount?.userEmail)}
      name={userName || t('linkedinUser')}
      meta={_.compact([linkedinAccount?.userEmail, productLabel]).join(' · ')}
      context={funnelName || '-'}
      contextLabel={t('campaign')}
      amount={`${unreadMessagesCount || '-'}`}
      actionText={t('replyTask')}
      handleAction={handleMessageReplyTaskClick(funnelId, linkedinAccount?._id)}
    />
  );
};

interface Props {
  tasks: TmMessageReplyTask[];
  total: number | undefined;

  handleMessageReplyTaskClick(funnelId: string, liAccountId: string): () => void;
}

const TmMessageReply: React.FC<Props> = ({ tasks, total, handleMessageReplyTaskClick }) => {
  const { t } = useTranslation();

  return (
    <TmSectionCard
      icon={<ReplyIcon fontSize={'small'} />}
      iconBackground={'#daf696'}
      iconColor={'#2C5A00'}
      title={t('replyMessages')}
      count={total}
      hint={t('replyMessagesHint')}
    >
      {tasks.map((task, index) => (
        <TaskItem key={index} task={task} handleMessageReplyTaskClick={handleMessageReplyTaskClick} />
      ))}
    </TmSectionCard>
  );
};

export default TmMessageReply;
